export class FilterCriteria {
  numPiece: string;
  dateDebut: string;
  dateFin: string;
}
